export default [
  {
    name: "terrastation",
    text: "Terra Station",
    connectText: "Terra Station extension",
    desc: "Terra Station Extension by Terra Money.",
    logo: require("@/assets/icons/wallets/terrastation.svg"),
    active: true,
    authRequired: false,
    projects: ["terra", "terrav2"],
  },
  {
    name: "keystation",
    text: "Keystation",
    connectText: "Keystation by Cosmostation",
    desc: "End-to-end encrypted key manager.",
    logo: require("@/assets/icons/wallets/keystation.svg"),
    active: true,
    authRequired: false,
    projects: [
      "cosmos",
      "kava",
      "persistence",
      "band",
      "sentinel",
      "certik",
      "starname",
      "juno",
      "comdex",
      "gbridge",
      "akash",
      "sifchain",
    ],
  },
  {
    name: "walletconnect",
    text: "WalletConnect",
    connectText: "Wallet Connect",
    desc: "Bridging 20+ mobile wallet support for browser DApps.",
    logo: require("@/assets/icons/wallets/walletconnect.svg"),
    active: true,
    authRequired: false,
    projects: [
      "kyber",
      "ethereum",
      "skale",
      "thegraph",
      "celer",
      "cosmos",
      "solana",
    ],
  },
  {
    name: "ledger",
    text: "Ledger",
    connectText: "Ledger",
    desc: "Digital asset hardware wallet.",
    logo: require("@/assets/icons/wallets/ledger.svg"),
    logoDark: require("@/assets/icons/wallets/ledger-white.svg"),
    active: true,
    authRequired: false,
    projects: [
      "kyber",
      "ethereum",
      "cosmos",
      "kava",
      "band",
      "terra",
      "starname",
      "switcheo",
      "skale",
      "persistence",
      "sentinel",
      "thegraph",
      "osmosis",
      "certik",
      "celer",
      "juno",
      "comdex",
      "lum",
      "gbridge",
      "agoric",
      "akash",
      "sifchain",
      "archway",
      "terrav2",
      "passage3d",
      "quicksilver",
      "kujira",
      "celestia"
    ],
  },
  {
    name: "metamask",
    text: "Metamask",
    connectText: "Metamask",
    desc: "Web3 browser extension crypto wallet.",
    logo: require("@/assets/icons/wallets/metamask.svg"),
    active: true,
    authRequired: false,
    projects: ["kyber", "ethereum", "skale", "thegraph", "celer"],
  },
  {
    name: "keplr",
    text: "Keplr",
    connectText: "Keplr wallet by Chainapsis",
    desc: "Interchain browser extension wallet.",
    logo: require("@/assets/icons/wallets/keplr.svg"),
    active: true,
    authRequired: false,
    projects: [
      "cosmos",
      "kava",
      "starname",
      "persistence",
      "sentinel",
      "osmosis",
      "certik",
      "juno",
      "comdex",
      "lum",
      "gbridge",
      "evmos",
      "agoric",
      "injective",
      "akash",
      "sifchain",
      "terra",
      "archway",
      "terrav2",
      "passage3d",
      "quicksilver",
      "kujira",
      "celestia",
      "dydx",
      "dymension",
      "canto",
    ],
  },
  {
    name: "leap",
    text: "Leap",
    connectText: "Leap wallet by Hyphen Labs",
    desc: "Leap is the only Cosmos wallet you’ll ever need.",
    logo: require("@/assets/icons/wallets/leap.svg"),
    active: true,
    authRequired: false,
    projects: [
      "cosmos",
      "kava",
      "starname",
      "persistence",
      "sentinel",
      "osmosis",
      "certik",
      "juno",
      "comdex",
      "lum",
      "gbridge",
      "evmos",
      "agoric",
      "injective",
      "akash",
      "sifchain",
      "terra",
      "archway",
      "terrav2",
      "passage3d",
      "quicksilver",
      "kujira",
      "celestia",
      "dydx",
      "dymension",
      "canto"
    ],
  },
  {
    name: "torus",
    text: "Torus",
    connectText: "Torus",
    desc: "One-click digital asset wallet.",
    logo: require("@/assets/icons/wallets/torus.svg"),
    active: true,
    authRequired: false,
    projects: ["kyber", "ethereum", "skale", "thegraph", "celer"],
  },
  {
    name: "fortmatic",
    text: "Fortmatic",
    connectText: "Fortmatic",
    desc: "Easy-to-use alternative to Web3 wallets.",
    logo: require("@/assets/icons/wallets/fortmatic.svg"),
    active: true,
    authRequired: false,
    projects: ["kyber", "ethereum", "skale", "thegraph", "celer"],
  },

  {
    name: "metamaskEvmos",
    type: "metamask",
    text: "Metamask",
    connectText: "Metamask",
    desc: "Web3 browser extension crypto wallet.",
    logo: require("@/assets/icons/wallets/metamask.svg"),
    active: true,
    authRequired: false,
    projects: ["evmos", "canto", "dymension"],
  },
  {
    name: "imtoken",
    text: "imToken",
    connectText: "imToken",
    desc: "Easy and secure digital wallet trusted by millions.",
    logo: require("@/assets/icons/wallets/imtoken.svg"),
    active: true,
    authRequired: false,
    projects: ["kyber", "ethereum", "skale", "thegraph", "celer"],
  },
  {
    name: "gnosis",
    text: "Gnosis Safe",
    connectText: "Gnosis Safe",
    desc: "The most trusted platform to manage digital assets on Ethereum.",
    logo: require("@/assets/icons/wallets/gnosis.svg"),
    logoDark: require("@/assets/icons/wallets/gnosis-white.svg"),
    active: true,
    authRequired: true,
    projects: ["ethereum"],
  },
  {
    name: "trezor",
    text: "Trezor",
    connectText: "Trezor",
    desc: "Digital asset hardware wallet.",
    logo: require("@/assets/icons/wallets/trezor.png"),
    active: true,
    authRequired: false,
    projects: ["kyber", "ethereum", "skale", "thegraph", "celer"],
  },
  {
    name: "phantom",
    text: "Phantom",
    connectText: "Phantom",
    desc: "Phantom wallet",
    logo: require("@/assets/icons/wallets/phantom.svg"),
    active: true,
    authRequired: false,
    projects: ["solana"],
  },
  {
    name: "martian",
    text: "Martian",
    connectText: "Martian",
    desc: "Martian wallet",
    logo: require("@/assets/icons/wallets/martian.png"),
    active: true,
    authRequired: false,
    projects: ["sui"],
  },
];
